<template>
  <div class="Breadcrumb_out">
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_in" separator="/">
        <el-breadcrumb-item>
          {{ Pagename }}
          <i class="el-icon-refresh-left" @click="relodePage"></i>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      Pagename: "",
    };
  },
  mounted() {
    this.setBreadcrumb();
  },

  watch: {
    $route(to, from) {
      this.setBreadcrumb();
    },
  },
  methods: {
    /**
     * 刷新页面
     * */

    relodePage() {
      location.reload();
    },
    setBreadcrumb() {
      let matched = this.$route.matched;
      this.Pagename = matched[0].meta.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.Breadcrumb_out {
  height: 2.875rem;
  .Breadcrumb {
    width: 100%;
    height: 2.375rem;
    background: #ffffff;
    box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.16);
    display: flex;
    align-items: center;
    user-select: none;
    .Breadcrumb_in {
      margin-left: 0.5rem;
    }
  }
  .restart_icon {
    width: 1rem;
    height: 1rem;
    margin-left: 0.5rem;
  }
}
.Breadcrumb_out
  :deep(.el-breadcrumb__item:last-child
    .el-breadcrumb__inner, .el-breadcrumb__item:last-child
    .el-breadcrumb__inner
    a, .el-breadcrumb__item:last-child
    .el-breadcrumb__inner
    a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover) {
  cursor: pointer;
  user-select: nono;
  color: #b7282d;
  font-weight: 600;
}
</style>